import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { hotTopics } from "@/mocks/hotList";

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-secondary-900 text-background-100">
      <div className="grid grid-cols-1 gap-10 px-4 py-12 md:px-8 md:py-16 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Link to="/" className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-black text-background-50">
              52
            </span>
            <span className="font-heading text-lg font-black tracking-tight text-background-50">
              吃瓜网
            </span>
          </Link>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-200/90 font-label">
            52吃瓜网把今天全网讨论度最高的话题按时间线整理成一条条事件记录，从起因、进展到当事方的公开回应，帮你在几分钟内看清一件事的来龙去脉。
          </p>
          <div className="mt-5 flex items-center gap-2.5">
            {["ri-wechat-line", "ri-weibo-line", "ri-bilibili-line", "ri-mail-line"].map((icon) => (
              <span
                key={icon}
                className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-background-50/10 text-lg text-background-100 transition-colors hover:bg-primary-500 hover:text-background-50"
              >
                <i className={icon}></i>
              </span>
            ))}
          </div>
        </div>

        <div className="lg:col-span-2">
          <h4 className="font-heading text-sm font-bold text-background-50">内容分类</h4>
          <ul className="mt-4 flex flex-col gap-2.5">
            {categories.map((cat) => (
              <li key={cat.slug}>
                <Link
                  to={`/category/${cat.slug}`}
                  className="text-sm font-label text-background-200/90 transition-colors hover:text-accent-300"
                >
                  {cat.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-3">
          <h4 className="font-heading text-sm font-bold text-background-50">今日热议</h4>
          <ul className="mt-4 flex flex-col gap-2.5">
            {hotTopics.slice(0, 5).map((topic) => (
              <li key={topic.rank}>
                <Link
                  to={`/article/${topic.articleId}`}
                  className="line-clamp-1 text-sm font-label text-background-200/90 transition-colors hover:text-accent-300"
                >
                  {topic.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-3">
          <h4 className="font-heading text-sm font-bold text-background-50">网站导航</h4>
          <ul className="mt-4 flex flex-col gap-2.5">
            {[
              { to: "/hot", label: "实时热度榜" },
              { to: "/about", label: "关于我们" },
              { to: "/contact", label: "联系我们 / 投稿" },
            ].map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  className="text-sm font-label text-background-200/90 transition-colors hover:text-accent-300"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
          <p className="mt-5 text-xs leading-relaxed text-background-300/80 font-label">
            内容基于公开信息整理，热点事件请以当事方官方回应为准。
          </p>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="flex flex-col items-start gap-2 px-4 py-5 text-xs font-label text-background-300/80 md:flex-row md:items-center md:justify-between md:px-8">
          <p>© 2026 52吃瓜网 · 今日热门与全网热议事件汇总</p>
          <p>理性吃瓜 · 尊重事实 · 拒绝传谣</p>
        </div>
      </div>
    </footer>
  );
}